export default __webpack_public_path__ + "static/media/king_white.3f959aab.svg";